module.exports = __webpack_public_path__ + "media/images/Bars/icon-back-incircle-34952c0cb6b4e8afcf28ba23c11f6cfa.png";